var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPolkadot = function SvgPolkadot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#polkadot_svg__a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.866 6.956c1.878 0 3.401-.886 3.401-1.978S13.744 3 11.867 3c-1.879 0-3.401.886-3.401 1.978s1.522 1.978 3.4 1.978ZM11.866 21.859c1.878 0 3.401-.886 3.401-1.978 0-1.093-1.523-1.978-3.4-1.978-1.879 0-3.401.885-3.401 1.978 0 1.092 1.522 1.978 3.4 1.978ZM7.127 9.694c.94-1.627.933-3.389-.014-3.935-.946-.547-2.475.329-3.414 1.955-.939 1.627-.933 3.388.014 3.935.946.546 2.475-.329 3.414-1.955ZM20.032 17.144c.939-1.626.933-3.388-.012-3.934-.947-.546-2.475.33-3.414 1.956-.939 1.627-.933 3.388.013 3.934.946.546 2.474-.33 3.413-1.956ZM7.114 19.1c.947-.547.953-2.308.014-3.935-.94-1.626-2.468-2.502-3.415-1.955-.946.546-.952 2.308-.013 3.934.939 1.627 2.467 2.502 3.414 1.956ZM20.02 11.65c.946-.547.952-2.308.013-3.935-.94-1.626-2.468-2.502-3.414-1.956-.945.547-.951 2.308-.012 3.934.94 1.627 2.467 2.503 3.413 1.956Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "polkadot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(3 3)",
    d: "M0 0h18v18.86H0z"
  })))));
};

export default SvgPolkadot;